import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './modules/login/login.component';
import {LogoutComponent} from './modules/login/logout/logout.component';
import {AdminThemeComponent} from './common/admin-theme/admin-theme.component';
import {AuthGuard} from './guards/auth.guard';



const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    redirectTo: 'users/list',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AdminThemeComponent,
    canActivate: [],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./modules/users-management/users-management.module').then(m => m.UsersManagementModule),
      },
      {
        path: 'groups',
        loadChildren: () => import('./modules/groups/groups.module').then(m => m.GroupsModule)
      },
      {
        path: 'posts',
        loadChildren: () => import('./modules/posts/posts.module').then(m => m.PostsModule)
      },
      {
      path: 'reports',
      loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
